import { Chip, TableCell, TableRow, Typography } from "@mui/material";
import type { FC } from "react";
import type { AcquiredCustomerRow } from "../statisticsApi";
import ReportTable, { CustomerLink } from "./ReportTable";

const STATUS_LABELS: Record<AcquiredCustomerRow["newStatus"], string> = {
  LEAD: "Lead",
  ACTIVE_LEAD: "Active Lead",
};

const COLUMNS = [{ label: "Klient" }, { label: "Nowy status" }, { label: "Data" }, { label: "Sprzedawca" }];

interface Props {
  readonly rows: AcquiredCustomerRow[];
}

const AcquiredCustomersTable: FC<Props> = ({ rows }) => {
  if (rows.length === 0) {
    return <Typography sx={{ color: "text.secondary" }}>Brak pozyskanych klientów w wybranym okresie</Typography>;
  }
  return (
    <ReportTable columns={COLUMNS}>
      {rows.map((row, index) => (
        <TableRow key={`${row.customerId}-${row.date}-${index}`} hover>
          <TableCell>
            <CustomerLink customerId={row.customerId} customerName={row.customerName} />
          </TableCell>
          <TableCell>
            <Chip
              label={STATUS_LABELS[row.newStatus]}
              size="small"
              variant="outlined"
              color={row.newStatus === "ACTIVE_LEAD" ? "success" : "default"}
            />
          </TableCell>
          <TableCell>{row.date}</TableCell>
          <TableCell>{row.sellerName}</TableCell>
        </TableRow>
      ))}
    </ReportTable>
  );
};

export default AcquiredCustomersTable;
